var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5"},[_c('v-row',[_c('v-col',{staticClass:"d-flex flex-row align-center justify-center flex-wrap",attrs:{"cols":"12"}},[(_vm.researches)?_c('v-btn',{staticClass:"ma-2",attrs:{"color":"success","outlined":""},on:{"click":_vm.exportTable}},[_c('v-icon',[_vm._v("mdi-file-excel-outline")]),_c('span',[_vm._v("Exporter cette étude")])],1):_vm._e()],1),_c('v-col',{attrs:{"cols":"12"}},[_c('v-simple-table',[_c('thead',[_c('tr',[_c('th',{staticClass:"by-1 br-1 bl-1 text-center",attrs:{"rowspan":3}},[_vm._v("Univers")]),_c('th',{staticClass:"by-1 br-1 text-center",attrs:{"rowspan":3}},[_vm._v("Équipe")]),_c('th',{staticClass:"by-1 br-1 bl-1 text-center",attrs:{"rowspan":3}},[_vm._v(" Capital social ")]),_vm._l((_vm.periods),function(period){return (!_vm.compactMode)?_c('th',{staticClass:"by-1 br-1 bl-1 text-center",attrs:{"colspan":"5"},domProps:{"textContent":_vm._s(period.name)}}):_vm._e()}),_c('th',{staticClass:"by-1 br-1 bl-1 text-center",attrs:{"colspan":"9"}},[_vm._v("Total")])],2),_c('tr',[_vm._l((_vm.periods),function(period){return (!_vm.compactMode)?[_c('th',{staticClass:"bb-1 br-1 bl-1 text-center",attrs:{"colspan":"2"}},[_vm._v("Resultat")]),_c('th',{staticClass:"bb-1 br-1 text-center",attrs:{"colspan":"2"}},[_vm._v("Rentabilité")]),_c('th',{staticClass:"bb-1 br-1 text-center",attrs:{"rowspan":"2"}},[_vm._v("Subvention")])]:_vm._e()}),_c('th',{staticClass:"bb-1 br-1 bl-1 text-center",attrs:{"colspan":"4"}},[_vm._v("Resultat")]),_c('th',{staticClass:"bb-1 br-1 text-center",attrs:{"colspan":"4"}},[_vm._v("Rentabilité")]),_c('th',{staticClass:"bb-1 br-1 text-center",attrs:{"rowspan":"2"}},[_vm._v("Subvention")])],2),_c('tr',[_vm._l((_vm.periods),function(period){return (!_vm.compactMode)?[_c('th',{staticClass:"bb-1 br-1 bl-1 text-center"},[_vm._v("Avec subventions")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Classement")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Avec subventions")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Classement")])]:_vm._e()}),_c('th',{staticClass:"bb-1 br-1 bl-1 text-center"},[_vm._v("Avec subventions")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Classement (avec subv)")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Sans subventions")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Classement (Sans subv)")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Avec subventions")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Classement (avec subv)")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Sans subventions")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Classement (Sans subv)")])],2)]),_c('tbody',[_vm._l((Object.keys(_vm.orderedTeams)),function(universId){return [_c('tr',[_c('th',{staticClass:"border",staticStyle:{"height":"3px"},attrs:{"colspan":_vm.compactMode ? 12 : 12 + 5 * _vm.periods.length}})]),_vm._l((_vm.orderedTeams[universId]),function(team,teamIndex){return _c('tr',[(teamIndex == 0)?_c('td',{staticClass:"bb-1 br-1 bl-1 text-center",attrs:{"rowspan":_vm.orderedTeams[universId].length},domProps:{"textContent":_vm._s(_vm.universeTable[universId].name)}}):_vm._e(),_c('td',{staticClass:"bb-1 br-1 text-center",domProps:{"textContent":_vm._s(team.name + '-' + team.publicName)}}),_c('td',{staticClass:"bb-1 br-1 bl-1 text-center",domProps:{"textContent":_vm._s(
                  _vm.dataFormater.formatMoney(
                    _vm.researches.resultResearch[universId][team.id].total
                      .socialCapital
                  )
                )}}),_vm._l((_vm.periods),function(period){return (!_vm.compactMode)?[_c('td',{class:'bb-1 br-1 bl-1 text-center' +
                    (_vm.researches.resultResearch[universId][team.id].data[
                      period.id
                    ].rankByValue.byUnivers == 1
                      ? ' univers-max'
                      : '') +
                    (_vm.researches.resultResearch[universId][team.id].data[
                      period.id
                    ].rankByValue.byUnivers == _vm.orderedTeams[universId].length
                      ? ' univers-min'
                      : '') +
                    (_vm.researches.resultResearch[universId][team.id].data[
                      period.id
                    ].rankByValue.all == 1
                      ? ' global-max'
                      : '') +
                    (_vm.researches.resultResearch[universId][team.id].data[
                      period.id
                    ].rankByValue.all == _vm.orderedTeams[universId].length
                      ? ' global-min'
                      : ''),domProps:{"textContent":_vm._s(
                    _vm.dataFormater.formatMoney(
                      _vm.researches.resultResearch[universId][team.id].data[
                        period.id
                      ].value
                    )
                  )}}),_c('td',{staticClass:"bb-1 br-1 text-center"},[_c('span',{domProps:{"textContent":_vm._s(
                      _vm.researches.resultResearch[universId][team.id].data[
                        period.id
                      ].rankByValue.byUnivers
                    )}}),_c('sup',[_vm._v("e")])]),_c('td',{class:'bb-1 br-1 text-center' +
                    (_vm.researches.resultResearch[universId][team.id].data[
                      period.id
                    ].rankByRentability.byUnivers == 1
                      ? ' univers-max'
                      : '') +
                    (_vm.researches.resultResearch[universId][team.id].data[
                      period.id
                    ].rankByRentability.byUnivers ==
                    _vm.orderedTeams[universId].length
                      ? ' univers-min'
                      : '') +
                    (_vm.researches.resultResearch[universId][team.id].data[
                      period.id
                    ].rankByRentability.all == 1
                      ? ' global-max'
                      : '') +
                    (_vm.researches.resultResearch[universId][team.id].data[
                      period.id
                    ].rankByRentability.all == _vm.orderedTeams[universId].length
                      ? ' global-min'
                      : ''),domProps:{"textContent":_vm._s(
                    _vm.dataFormater.formatPercentage(
                      _vm.researches.resultResearch[universId][team.id].data[
                        period.id
                      ].rentability
                    )
                  )}}),_c('td',{staticClass:"bb-1 br-1 text-center"},[_c('span',{domProps:{"textContent":_vm._s(
                      _vm.researches.resultResearch[universId][team.id].data[
                        period.id
                      ].rankByRentability.byUnivers
                    )}}),_c('sup',[_vm._v("e")])]),_c('td',{staticClass:"bb-1 br-1 text-center",domProps:{"textContent":_vm._s(
                    _vm.dataFormater.formatMoney(
                      _vm.researches.resultResearch[universId][team.id].data[
                        period.id
                      ].subventions
                    )
                  )}})]:_vm._e()}),_c('td',{class:'bb-1 br-1 bl-1 text-center' +
                  (_vm.researches.resultResearch[universId][team.id].total
                    .withSubvention.rankByValue.byUnivers == 1
                    ? ' univers-max'
                    : '') +
                  (_vm.researches.resultResearch[universId][team.id].total
                    .withSubvention.rankByValue.byUnivers ==
                  _vm.orderedTeams[universId].length
                    ? ' univers-min'
                    : '') +
                  (_vm.researches.resultResearch[universId][team.id].total
                    .withSubvention.rankByValue.all == 1
                    ? ' global-max'
                    : '') +
                  (_vm.researches.resultResearch[universId][team.id].total
                    .withSubvention.rankByValue.all ==
                  _vm.orderedTeams[universId].length
                    ? ' global-min'
                    : ''),domProps:{"textContent":_vm._s(
                  _vm.dataFormater.formatMoney(
                    _vm.researches.resultResearch[universId][team.id].total
                      .withSubvention.value
                  )
                )}}),_c('td',{staticClass:"bb-1 br-1 text-center"},[_c('span',{domProps:{"textContent":_vm._s(
                    _vm.researches.resultResearch[universId][team.id].total
                      .withSubvention.rankByValue.byUnivers
                  )}}),_c('sup',[_vm._v("e")])]),_c('td',{class:'bb-1 br-1 text-center' +
                  (_vm.researches.resultResearch[universId][team.id].total
                    .withoutSubvention.rankByValue.byUnivers == 1
                    ? ' univers-max'
                    : '') +
                  (_vm.researches.resultResearch[universId][team.id].total
                    .withoutSubvention.rankByValue.byUnivers ==
                  _vm.orderedTeams[universId].length
                    ? ' univers-min'
                    : '') +
                  (_vm.researches.resultResearch[universId][team.id].total
                    .withoutSubvention.rankByValue.all == 1
                    ? ' global-max'
                    : '') +
                  (_vm.researches.resultResearch[universId][team.id].total
                    .withoutSubvention.rankByValue.all ==
                  _vm.orderedTeams[universId].length
                    ? ' global-min'
                    : ''),domProps:{"textContent":_vm._s(
                  _vm.dataFormater.formatMoney(
                    _vm.researches.resultResearch[universId][team.id].total
                      .withoutSubvention.value
                  )
                )}}),_c('td',{staticClass:"bb-1 br-1 text-center"},[_c('span',{domProps:{"textContent":_vm._s(
                    _vm.researches.resultResearch[universId][team.id].total
                      .withSubvention.rankByValue.byUnivers
                  )}}),_c('sup',[_vm._v("e")])]),_c('td',{class:'bb-1 br-1 text-center' +
                  (_vm.researches.resultResearch[universId][team.id].total
                    .withSubvention.rankByRentability.byUnivers == 1
                    ? ' univers-max'
                    : '') +
                  (_vm.researches.resultResearch[universId][team.id].total
                    .withSubvention.rankByRentability.byUnivers ==
                  _vm.orderedTeams[universId].length
                    ? ' univers-min'
                    : '') +
                  (_vm.researches.resultResearch[universId][team.id].total
                    .withSubvention.rankByRentability.all == 1
                    ? ' global-max'
                    : '') +
                  (_vm.researches.resultResearch[universId][team.id].total
                    .withSubvention.rankByRentability.all ==
                  _vm.orderedTeams[universId].length
                    ? ' global-min'
                    : ''),domProps:{"textContent":_vm._s(
                  _vm.dataFormater.formatPercentage(
                    _vm.researches.resultResearch[universId][team.id].total
                      .withSubvention.rentability
                  )
                )}}),_c('td',{staticClass:"bb-1 br-1 text-center"},[_c('span',{domProps:{"textContent":_vm._s(
                    _vm.researches.resultResearch[universId][team.id].total
                      .withSubvention.rankByRentability.byUnivers
                  )}}),_c('sup',[_vm._v("e")])]),_c('td',{class:'bb-1 br-1 text-center' +
                  (_vm.researches.resultResearch[universId][team.id].total
                    .withoutSubvention.rankByRentability.byUnivers == 1
                    ? ' univers-max'
                    : '') +
                  (_vm.researches.resultResearch[universId][team.id].total
                    .withoutSubvention.rankByRentability.byUnivers ==
                  _vm.orderedTeams[universId].length
                    ? ' univers-min'
                    : '') +
                  (_vm.researches.resultResearch[universId][team.id].total
                    .withoutSubvention.rankByRentability.all == 1
                    ? ' global-max'
                    : '') +
                  (_vm.researches.resultResearch[universId][team.id].total
                    .withoutSubvention.rankByRentability.all ==
                  _vm.orderedTeams[universId].length
                    ? ' global-min'
                    : ''),domProps:{"textContent":_vm._s(
                  _vm.dataFormater.formatPercentage(
                    _vm.researches.resultResearch[universId][team.id].total
                      .withoutSubvention.rentability
                  )
                )}}),_c('td',{staticClass:"bb-1 br-1 text-center"},[_c('span',{domProps:{"textContent":_vm._s(
                    _vm.researches.resultResearch[universId][team.id].total
                      .withSubvention.rankByRentability.byUnivers
                  )}}),_c('sup',[_vm._v("e")])]),_c('td',{class:'bb-1 br-1 text-center' +
                  (_vm.researches.resultResearch[universId][team.id].total
                    .rankBySubventions.byUnivers == 1
                    ? ' univers-max'
                    : '') +
                  (_vm.researches.resultResearch[universId][team.id].total
                    .rankBySubventions.byUnivers ==
                  _vm.orderedTeams[universId].length
                    ? ' univers-min'
                    : '') +
                  (_vm.researches.resultResearch[universId][team.id].total
                    .rankBySubventions.all == 1
                    ? ' global-max'
                    : '') +
                  (_vm.researches.resultResearch[universId][team.id].total
                    .rankBySubventions.all == _vm.orderedTeams[universId].length
                    ? ' global-min'
                    : ''),domProps:{"textContent":_vm._s(
                  _vm.dataFormater.formatMoney(
                    _vm.researches.resultResearch[universId][team.id].total
                      .subventions
                  )
                )}})],2)})]})],2)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }